import { Button, alpha } from "@mui/material"

const StyledButton = ({ variant = "contained", color = "primary", size = "medium", children, sx = {}, ...props }) => {
  const getButtonStyles = () => {
    const baseStyles = {
      borderRadius: 2,
      textTransform: "none",
      fontWeight: 600,
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    }

    if (variant === "contained") {
      return {
        ...baseStyles,
        background: "linear-gradient(135deg, #96D232 0%, #7AB829 100%)",
        color: "#fff",
        boxShadow: "0 4px 12px rgba(150, 210, 50, 0.3)",
        "&:hover": {
          background: "linear-gradient(135deg, #7AB829 0%, #6BA020 100%)",
          boxShadow: "0 6px 20px rgba(150, 210, 50, 0.4)",
          transform: "translateY(-1px)",
        },
        "&:active": {
          transform: "translateY(0)",
        },
      }
    }

    if (variant === "outlined") {
      return {
        ...baseStyles,
        borderColor: "#96D232",
        color: "#96D232",
        backgroundColor: "transparent",
        "&:hover": {
          borderColor: "#7AB829",
          backgroundColor: alpha("#96D232", 0.1),
          transform: "translateY(-1px)",
        },
      }
    }

    return baseStyles
  }

  return (
    <Button
      variant={variant}
      color={color}
      size={size}
      sx={{
        ...getButtonStyles(),
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  )
}

export default StyledButton
